import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../auth/authConfig";
import { Button } from "@mui/material";
import "./LoginButton.css";

const LoginButton = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = async () => {
    // Heuristics
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const isInIframe = window.self !== window.top;
    const isMobile = isIOS || isAndroid;

    try {
      if (isMobile || isSafari || isInIframe) {
        await instance.loginRedirect(loginRequest);
        return;
      }

      // Desktop: try popup first
      await instance.loginPopup(loginRequest);
    } catch (e) {
      // Fallback if popup is blocked or fails
      await instance.loginRedirect(loginRequest);
    }
  };

  return (
    <Button
      onClick={handleLogin}
      disabled={isAuthenticated}
      variant="contained"
      color="primary"
      className="login-button"
    >
      Sign In
    </Button>
  );
};

export default LoginButton;
